import {QueryParams} from '@ngrx/data';

export class UrlHelper {

    public static formatInitialFormStateAsQueryParam(initialFormState: any): QueryParams {
        // console.log(['json', JSON.stringify(initialFormState)]);
        return {
            initialFormState: btoa(JSON.stringify(initialFormState))
        };
    }

    public static formatUrl(baseUrl: string, params: string | QueryParams): string {
        // console.dir(params);
        let url = baseUrl;
        if (url.endsWith('/')) {
            url = url.substring(0, url.length - 1);
        }
        if (params) {
            let counter = 0;
            if (params instanceof String) {
                url += '?' + params;
            } else {
                Object.keys(params).forEach((value, index) => {
                    // // console.logByTypevalue + ' -> ' + params[value] + ' -> ' + index + ' -> ' + value);
                    url += (counter === 0) ? '?' : '&';
                    url += value + '=' + params[value];
                    counter ++;
                });
            }
        }
        return url;
    }
}
